import { render, staticRenderFns } from "./VCol.vue?vue&type=template&id=9aad1cce&"
import script from "./VCol.vue?vue&type=script&lang=js&"
export * from "./VCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports